import { observer, useLocalObservable } from 'mobx-react';
import { Button, Divider, Grid, ListItemText, Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import { useDialogState } from 'hooks/useDialogState';
import MyPageStore from '../store/MyPageStore';
import BasicImage from './BasicImage';

interface Props {
  pageStore: MyPageStore;
}

function MyPageTopArea(props: Props) {
  const { pageStore } = props;
  const { myInfo } = pageStore;
  const { isOpen: isDialogOpen, open: openDialog, close: closeDialog } = useDialogState();

  const handleClickGoalBtn = () => {
    pageStore.setIsOpenModal(true);
  };

  return (
    <Grid container>
      <Typography
        style={{
          fontStyle: 'normal',
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '16px',
          color: '#171918',
        }}
      >
        My Information
      </Typography>

      <Grid container alignItems={'center'} style={{ marginTop: '30px' }}>
        {myInfo.userData?.profile ? (
          <BasicImage
            src={myInfo.userData?.profile}
            style={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              objectFit: 'cover',
              overflow: 'hidden',
            }}
          />
        ) : (
          <Avatar>
            <ImageIcon
              sx={{
                borderRadius: '50%',
                objectFit: 'cover',
                overflow: 'hidden',
              }}
            />
          </Avatar>
        )}

        <ListItemText
          primary={
            <span
              style={{
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '16px',
                color: '#000000',
              }}
            >
              {myInfo?.names?.fullname}
            </span>
          }
          secondary={
            <span
              style={{
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                color: '#212121',
              }}
            >
              {myInfo.userData.jobTitle}
              {'  '}
              <span
                style={{
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '12px',
                  color: '#6C6B6F',
                }}
              >
                {myInfo.userData.deptName}
              </span>
            </span>
          }
          style={{
            margin: 0,
            marginLeft: '16px',
          }}
        />
      </Grid>

      <Grid
        container
        gap={2}
        style={{
          background: '#F7F7F7',
          borderRadius: '10px',
          padding: '30px 20px',
          marginTop: '30px',
        }}
      >
        <Grid container>
          <Grid>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                color: '#ABABAB',
              }}
            >
              아이디
            </Typography>
          </Grid>
          <Grid>
            <Typography
              style={{
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                color: '#212121',
                marginLeft: '16px',
              }}
            >
              {myInfo.username}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                color: '#ABABAB',
              }}
            >
              E-mail
            </Typography>
          </Grid>
          <Grid>
            <Typography
              style={{
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                color: '#212121',
                marginLeft: '16px',
              }}
            >
              {myInfo.email}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                color: '#ABABAB',
              }}
            >
              Phone
            </Typography>
          </Grid>
          <Grid>
            <Typography
              style={{
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '14px',
                color: '#212121',
                marginLeft: '16px',
              }}
            >
              {myInfo.phones?.mobile}
            </Typography>
          </Grid>
        </Grid>
        <Button
          style={{
            margin: '0 5 0 5',
            background: '#2281D0',
            borderRadius: '10px',
            color: '#ffffff',
            fontWeight: 500,
            width: '100%',
            padding: '15px 0',
            fontSize: '14px',
            lineHeight: '14px',
            cursor: 'pointer',
          }}
          onClick={handleClickGoalBtn}
          variant='contained'
        >
          Goals
        </Button>
      </Grid>
    </Grid>
  );
}

export default observer(MyPageTopArea);
